/**
 * Scales CSS properties based on data attributes and a given scalar.
 */
jQuery.fn.scale = function(/*number*/ scale)
{
	var attributeDirectly = {
		canvas: {
			width: 			'width',
			height: 		'height'
		}
	};
	
	var normalScaled = {
		border: 			'borderWidth',
		font: 				'fontSize',
		left: 				'left',
		top: 					'top',
		right: 				'right',
		bottom: 			'bottom',
		padding: 			'padding',
		paddingLeft: 	'paddingLeft',
		paddingRight: 'paddingRight',
		paddingTop: 	'paddingTop',
		paddingBottom:'paddingBottom',
		margin: 			'margin',
		marginLeft: 	'marginLeft',
		marginRight: 	'marginRight',
		marginTop: 		'marginTop',
		marginBottom: 'marginBottom',
		borderRadius: 'borderRadius'
	};
	
	var elementScaled = {
		width: 				'width',
		height: 			'height',
		lineHeight: 		'lineHeight'
	};
	
	this.each(function()
	{
		var element = $(this);
		
		var tag = element.prop('tagName').toLowerCase();
		
		if (element.data('rect'))
		{
			var comps = element.data('rect').split(',');
			
			element.data( 'left', 	parseFloat(comps[0]) );
			element.data( 'top', 	parseFloat(comps[1]) );
			element.data( 'width', 	parseFloat(comps[2]) );
			element.data( 'height', parseFloat(comps[3]) );
			
			element.data('rect', null);
			element.removeAttr('data-rect');
		}
		
		var data = element.data();
		var css = {};
		
		var elementScale = scale;
		
		if ('scale' in data)
		{
			var modifierScale = parseFloat(data.scale);
			
			if (!isNaN(modifierScale))
			{
				elementScale *= modifierScale;
			}
		}
		
		for (var property in elementScaled)
		{
			if (property in data)
			{
				if (tag in attributeDirectly && property in attributeDirectly[tag])
				{
					element.attr( property, parseFloat(data[property]) * elementScale );
				}
				else
				{
					css[elementScaled[property]] = (parseFloat(data[property]) * elementScale) + 'px';	
				}
			}
		}
		
		for (var property in normalScaled)
		{
			if (property in data)
			{
				if (tag in attributeDirectly && property in attributeDirectly[tag])
				{
					element.attr( property, parseFloat(data[property]) * scale );
				}
				else
				{
					css[normalScaled[property]] = (parseFloat(data[property]) * scale) + 'px';	
				}
			}
		}
		
		element.css( css );
		element.trigger( 'scaled' );
	});
	
	return this;
};